// Build-your-kitchen page. No framework: BBQ + module selection state lives
// in this file, rendered into the existing DOM (Liquid already drew every
// card; this only toggles classes/attrs and fills the summary card).
// "Add to cart" posts every selected line as one multi-item /cart/add.js
// request, so real per-item shipping sums at checkout instead of a
// hand-maintained bundle rate. See AIOS project note
// hhh-outdoor-kitchen-builder-page.md for why this replaced the bundle SKUs.
(function () {
  function money(n) {
    return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: n % 1 ? 2 : 0 }).format(n);
  }

  function init(root) {
    const bbqCards = Array.from(root.querySelectorAll("[data-kb-bbq]"));
    const moduleCards = Array.from(root.querySelectorAll("[data-kb-module]"));
    const summaryEmpty = root.querySelector("[data-kb-summary-empty]");
    const summaryLines = root.querySelector("[data-kb-summary-lines]");
    const totalRow = root.querySelector("[data-kb-total]");
    const totalPriceEl = root.querySelector("[data-kb-total-price]");
    const metaRow = root.querySelector("[data-kb-meta]");
    const footprintEl = root.querySelector("[data-kb-footprint]");
    const noteEl = root.querySelector("[data-kb-note]");
    const cta = root.querySelector("[data-kb-cta]");
    const errorEl = root.querySelector("[data-kb-error]");

    let bbq = null; // { variantId, price, title, variantTitle, widthMm }
    const modules = {}; // key -> { qty, variantId, price, title, variantTitle, widthMm }

    function cardData(el) {
      return {
        variantId: el.dataset.variantId,
        price: parseFloat(el.dataset.price),
        title: el.dataset.title,
        variantTitle: el.dataset.variantTitle,
        widthMm: parseFloat(el.dataset.widthMm) || 0,
      };
    }

    function selectBbq(el) {
      bbqCards.forEach((c) => c.classList.toggle("is-selected", c === el));
      bbq = cardData(el);
      render();
    }

    function setModuleQty(key, el, qty) {
      const addBtn = el.querySelector("[data-kb-add-btn]");
      const qtyEl = el.querySelector("[data-kb-qty]");
      const qtyValue = el.querySelector("[data-kb-qty-value]");
      if (qty <= 0) {
        delete modules[key];
        el.classList.remove("is-selected");
        addBtn.hidden = false;
        qtyEl.hidden = true;
      } else {
        modules[key] = Object.assign(cardData(el), { qty });
        el.classList.add("is-selected");
        addBtn.hidden = true;
        qtyEl.hidden = false;
        qtyValue.textContent = String(qty);
      }
      render();
    }

    bbqCards.forEach((el) => el.addEventListener("click", () => selectBbq(el)));

    moduleCards.forEach((el) => {
      const key = el.dataset.kbModule;
      const addBtn = el.querySelector("[data-kb-add-btn]");
      const minus = el.querySelector("[data-kb-qty-minus]");
      const plus = el.querySelector("[data-kb-qty-plus]");
      addBtn.addEventListener("click", () => setModuleQty(key, el, 1));
      minus.addEventListener("click", () => setModuleQty(key, el, (modules[key]?.qty || 1) - 1));
      plus.addEventListener("click", () => setModuleQty(key, el, (modules[key]?.qty || 0) + 1));
    });

    function render() {
      errorEl.hidden = true;
      const moduleList = Object.values(modules);
      const hasAnything = !!bbq;

      summaryEmpty.hidden = hasAnything;
      summaryLines.hidden = !hasAnything;
      totalRow.hidden = !hasAnything;
      metaRow.hidden = !hasAnything;
      noteEl.hidden = !hasAnything;
      cta.disabled = !hasAnything;

      if (!hasAnything) return;

      let total = bbq.price;
      let widthMm = bbq.widthMm;
      let lineCount = 1;
      const rows = [lineLine(bbq.title, bbq.variantTitle, bbq.price)];

      moduleList.forEach((m) => {
        total += m.price * m.qty;
        widthMm += m.widthMm * m.qty;
        lineCount += 1;
        const label = m.qty > 1 ? `${m.title} ×${m.qty}` : m.title;
        rows.push(lineLine(label, m.variantTitle, m.price * m.qty));
      });

      summaryLines.innerHTML = rows.join("");
      totalPriceEl.textContent = money(total);
      footprintEl.textContent = `≈ ${(widthMm / 1000).toFixed(2)} m of bench (BBQ + ${moduleList.length} module${moduleList.length === 1 ? "" : "s"}). Measure your space before you order.`;
      cta.textContent = `Add ${lineCount} item${lineCount === 1 ? "" : "s"} to cart`;
    }

    function lineLine(name, variantTitle, price) {
      return `<div class="kb-line"><div><span class="kb-line-name">${escapeHtml(name)}</span><span class="kb-line-variant">${escapeHtml(variantTitle)}</span></div><span class="kb-line-price">${money(price)}</span></div>`;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    }

    cta.addEventListener("click", async () => {
      if (!bbq) return;
      cta.disabled = true;
      const originalLabel = cta.textContent;
      cta.textContent = "Adding…";
      errorEl.hidden = true;

      const items = [{ id: Number(bbq.variantId), quantity: 1 }];
      Object.values(modules).forEach((m) => items.push({ id: Number(m.variantId), quantity: m.qty }));

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.description || body.message || "Could not add to cart");
        }
        window.location.href = "/cart";
      } catch (err) {
        cta.disabled = false;
        cta.textContent = originalLabel;
        errorEl.textContent = err.message || "Something went wrong adding these to your cart. Please try again.";
        errorEl.hidden = false;
      }
    });

    render();
    initLightbox(root);
  }

  function initLightbox(root) {
    const lightbox = root.querySelector("[data-kb-lightbox]");
    if (!lightbox) return;
    const lightboxImg = lightbox.querySelector("[data-kb-lightbox-img]");
    const closeBtn = lightbox.querySelector("[data-kb-lightbox-close]");

    function open(img) {
      lightboxImg.src = img.dataset.full || img.currentSrc || img.src;
      lightboxImg.alt = img.alt || "";
      lightbox.showModal();
    }

    root.querySelectorAll(".kb-zoomable").forEach((img) => {
      img.addEventListener("click", (e) => {
        e.stopPropagation();
        open(img);
      });
      img.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          open(img);
        }
      });
    });

    closeBtn.addEventListener("click", () => lightbox.close());
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) lightbox.close();
    });
  }

  document.querySelectorAll("[data-kb-root]").forEach(init);
})();
